import React from "react"
import Layout from "gatsby-theme-blank/src/components/Layout/layout"
import PropTypes from "prop-types"
import SEO from "gatsby-theme-blank/src/components/seo"
import ListActualites from "gatsby-theme-blank/src/components/Home/Actualites/actualites"
import ContenuLibre from "../components/ContenuLibre/contenu-libre"
import CarnetAdresse from "gatsby-theme-blank/src/components/Home/MapCarnetAdresse/map-carnet-adresse"
import AgendaEvenements from "gatsby-theme-blank/src/components/Home/Agenda/agenda"
import ListNePasManquer from "../components/Home/NePasManquer/ne-pas-manquer"
import ListPartenaires from "gatsby-theme-blank/src/components/Home/Partenaires/partenaires"
import AccesDirects from "gatsby-theme-blank/src/components/Home/AccesDirect/acces-direct"
import {
  sectionFirst,
  sectionSecond,
  sectionThird,
  sectionFourth,
  sectionFifth,
  sectionNePasManquer,
  sectionPartenaires,
  sectionAdresse,
  divAccesDirect,
} from "../styles/index.module.scss"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import styled from "styled-components"
import BandeauAlert from "gatsby-theme-blank/src/components/BandeauAlert/bandeau-alert"
import NotificationPopup from "gatsby-theme-blank/src/components/NotificationPopup/notification-popup"
import { useAccesDirect } from "gatsby-theme-blank/src/components/Home/AccesDirect/acces-direct-query"

const IndexPage = ({ location }) => {
  const buildColors = useBuildData().theme_settings.palette
  const buildInfos = useBuildData().site_settings
  const dataAccesDirects = useAccesDirect()
  return (
    <Layout isIndex={true} message={buildInfos.website_name}>
      <SEO
        description={buildInfos.seo.description_tag}
        title={buildInfos.seo.title_tag || "Accueil"}
      />
      <BandeauAlert alertContent={buildInfos.alert_message.value} />
      <NotificationPopup
        popupContent={buildInfos.notification_popup.value}
        location={location}
      />
      <div className={sectionFirst}>
        <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_1" />
        <ListActualites />
      </div>
      <div
        style={{
          border: `1px solid ${buildColors.b_color_gradients.b_dark}`,
        }}
        className={sectionAdresse}
      >
        <CarnetAdresse />
      </div>
      <div className={sectionSecond}>
        {dataAccesDirects > 0 && (
          <div className={divAccesDirect}>
            <AccesDirects />
          </div>
        )}
        <AgendaEvenements />
      </div>
      <SectionWithBorder
        borderBottomColor="transparent"
        borderColor={buildColors.a_color_gradients.a_light}
        className={sectionThird}
      >
        <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_2" />
      </SectionWithBorder>
      <div
        style={{
          border: `1px solid ${buildColors.b_color_gradients.b_dark}`,
        }}
        className={sectionNePasManquer}
      >
        <ListNePasManquer />
      </div>
      <SectionWithBorder
        borderLeftColor={buildColors.a_color_gradients.a_light}
        borderColor="transparent"
        borderBottomColor={buildColors.a_color_gradients.a_light}
        className={sectionFourth}
      >
        <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_3" />
        <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_4" />
      </SectionWithBorder>
      <div className={sectionPartenaires}>
        <ListPartenaires />
      </div>
      <SectionWithBorder
        borderBottomColor="transparent"
        borderColor={buildColors.a_color_gradients.a_light}
        className={sectionFifth}
      >
        <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_5" />
      </SectionWithBorder>
    </Layout>
  )
}

//-----------------------Prop-Types---------------------------//

IndexPage.propTypes = {
  location: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default IndexPage

const SectionWithBorder = styled.div`
  &:not(:empty) {
    border-top: 1px solid ${(props) => props.borderColor};
    border-bottom: 1px solid ${(props) => props.borderBottomColor};
  }
  @media (min-width: 900px) {
    & > div + div {
      border-left: 1px solid ${(props) => props.borderLeftColor};
    }
  }
`
